import { render, staticRenderFns } from "./solution.vue?vue&type=template&id=f78630d0&scoped=true&"
import script from "./solution.vue?vue&type=script&lang=js&"
export * from "./solution.vue?vue&type=script&lang=js&"
import style0 from "./solution.vue?vue&type=style&index=0&id=f78630d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78630d0",
  null
  
)

export default component.exports